/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Invitation_Not_PendingInputs */

const en_error_invitation_not_pending = /** @type {(inputs: Error_Invitation_Not_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This user has already accepted the invitation, or is no longer invited.`)
};

/**
* | output |
* | --- |
* | "This user has already accepted the invitation, or is no longer invited." |
*
* @param {Error_Invitation_Not_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_invitation_not_pending = /** @type {((inputs?: Error_Invitation_Not_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Invitation_Not_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_invitation_not_pending(inputs)
});